"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  name: 'DetailTree',
  data: function data() {
    return {
      tableData: [], // 菜单列表数据
      tableData2: [], // 菜单筛选列表数据
      expandedKeys: [], // 默认展开的key
      checkedKeys: [], // 默认选中的key
      importDialog: false,
      checked: false,
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'label' } };


  },
  mounted: function mounted() {
    var self = this;
    self.getMenu();
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    } },

  methods: {
    // 获取数据
    getMenu: function getMenu(menuId) {// 菜单列表
      var self = this;
      var id = self.$route.query.id;
      self.expandedKeys = [];
      self.checkedKeys = [];
      self.expandedKeys.push(menuId);
      self.checkedKeys.push(menuId);
      console.log('default', self.expandedKeys);
      if (id) {
        self.getData('/api/deviceModelProtocol/' + self.$route.query.id + '/tree', {}, function (res) {
          self.tableData = res;
          for (var i = 0; i <= res.length; i++) {
            for (var j = 0; j < res[i].children.length; j++) {
              console.log('j', res[i].children[j]);
              if (res[i].children[j].alreadUse == true) {
                self.tableData2.push(res[i].children[j]);
                console.log('self.tableData2:', self.tableData2);
              }
            }
            console.log('i:', res[i]);
          }
        });
      }
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    changeScen: function changeScen(data) {// 获取模型详情
      // self.addData = JSON.parse(JSON.stringify(this.defaultData))
      console.log('data', data);
      this.$emit('handleGetContent', data);
    } } };exports.default = _default;